import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting, StandardLoadOptions } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ClaimService } from 'app/cd/services/claim-service';
import { apiCall } from 'app/shared/lib/api/api';
import * as CD from 'app/cd/models/essette-api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';


@autoinject()
export class ClaimBillingInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public claimId: string | null = null;

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected pageSize: number | undefined = 10;

    private sorting: Sorting = new Sorting();

    protected services: CD.Service[] = [];
    protected serviceResultCount: number = 0;

    ////****************** Element References ***************************************////
    protected $pagerServices!: EssPagerCustomElement;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly claimService: ClaimService,
        ...rest: any[]) {

        super(...rest);

        this.sorting.entries = [
            {
                reference: 'detail.attestedDate',
                direction: SortDirection.Descending
            }
        ];
    }

    protected bind(): void {
        this.reload();
    }


    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        await this.loadClaimServices();
    }

    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadClaimServices(): Promise<void> {
        if(!this.claimId) return;

        const options: StandardLoadOptions = {
            sorting: this.sorting,
            top: this.pageSize,
            page: this.$pagerServices?.page || 0,
            includeInactive: false
        };

        try {
            this.state.beginLoad();

            const responseServices = await this.claimService.loadServicesByClaim(this.claimId, options);
            this.services = responseServices.results;
            this.serviceResultCount = responseServices.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
